import React from "react";

import { Input, Space, Typography } from "antd";
import { GRAY_PLACEHOLDER, GRAY5 } from "../../constant/colors";
import FloatLabel from "./FloatLabel";

const { Text } = Typography;

const CustomInput = ({ children, style = {}, required = false, password, ...props }) => {
  return (
    <FloatLabel
      label={
        <Space size={4}>
          {required && <Text style={{ color: GRAY_PLACEHOLDER }}>*</Text>}
          <Text style={{ color: GRAY_PLACEHOLDER }}>{props.label}</Text>
        </Space>
      }
      name={props.label}
      value={props.value}
    >
      <Input
        {...props}
        type={password ? "password" : "text"}
        bordered={false}
        style={{
          width: "100%",
          border: "0px",
          borderRadius: "0",
          borderBottom: `1px solid ${GRAY5}`,
          padding: props.label ? "14px 0 0 11px" : "",
          ...style
        }}
      >
        {children}
      </Input>
    </FloatLabel>
  );
};

export { CustomInput };
